import axios from 'axios'
import { handleAlert } from '../../../views/components/ui/Alerts/Index'
import { responseCodeAlert } from '../utils'

// Dynamic action creators for the reusable import module
export const createImportActions = (moduleKey, endpoints) => {
  const types = {
    LIST_REQUEST: `${moduleKey}_LIST_REQUEST`,
    LIST_SUCCESS: `${moduleKey}_LIST_SUCCESS`,
    LIST_FAILURE: `${moduleKey}_LIST_FAILURE`,

    DETAIL_LIST_REQUEST: `${moduleKey}_DETAIL_LIST_REQUEST`,
    DETAIL_LIST_SUCCESS: `${moduleKey}_DETAIL_LIST_SUCCESS`,
    DETAIL_LIST_FAILURE: `${moduleKey}_DETAIL_LIST_FAILURE`,

    DETAIL_REQUEST: `${moduleKey}_DETAIL_REQUEST`,
    DETAIL_SUCCESS: `${moduleKey}_DETAIL_SUCCESS`,
    DETAIL_FAILURE: `${moduleKey}_DETAIL_FAILURE`,

    EXPORT_REQUEST: `${moduleKey}_EXPORT_REQUEST`,
    EXPORT_SUCCESS: `${moduleKey}_EXPORT_SUCCESS`,
    EXPORT_FAILURE: `${moduleKey}_EXPORT_FAILURE`,

    FILE_UPLOAD_REQUEST: `${moduleKey}_FILE_UPLOAD_REQUEST`,
    FILE_UPLOAD_SUCCESS: `${moduleKey}_FILE_UPLOAD_SUCCESS`,
    FILE_UPLOAD_FAILURE: `${moduleKey}_FILE_UPLOAD_FAILURE`,

    DOWNLOAD_TEMPLATE_REQUEST: `${moduleKey}_DOWNLOAD_TEMPLATE_REQUEST`,
    DOWNLOAD_TEMPLATE_SUCCESS: `${moduleKey}_DOWNLOAD_TEMPLATE_SUCCESS`,
    DOWNLOAD_TEMPLATE_FAILURE: `${moduleKey}_DOWNLOAD_TEMPLATE_FAILURE`
  }

  const listAction = (params) => async (dispatch) => {
    try {
      dispatch({ type: types.LIST_REQUEST })
      const config = { params: params || null }
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}${endpoints.list}`,
        config
      )
      dispatch({
        type: types.LIST_SUCCESS,
        payload: data.data,
        pageable: data.pageable
      })
    } catch (error) {
      dispatch({
        type: types.LIST_FAILURE,
        payload: error.response?.data?.message || error.message
      })
    }
  }

  const detailListAction = (id, params) => async (dispatch) => {
    try {
      dispatch({ type: types.DETAIL_LIST_REQUEST })
      const config = { params: params || null }
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}${endpoints.detailList(id)}`,
        config
      )
      dispatch({
        type: types.DETAIL_LIST_SUCCESS,
        payload: data.data,
        pageable: data.pageable
      })
    } catch (error) {
      dispatch({
        type: types.DETAIL_LIST_FAILURE,
        payload: error.response?.data?.message || error.message
      })
    }
  }

  const detailAction = (id) => async (dispatch) => {
    try {
      dispatch({ type: types.DETAIL_REQUEST })
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}${endpoints.detail(id)}`
      )
      dispatch({
        type: types.DETAIL_SUCCESS,
        payload: data.data
      })
    } catch (error) {
      dispatch({
        type: types.DETAIL_FAILURE,
        payload: error.response?.data?.message || error.message
      })
    }
  }

  const exportAction = (id, params, callback) => async (dispatch) => {
    try {
      dispatch({ type: types.EXPORT_REQUEST })
      const config = { params: params || null }
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}${endpoints.export(id)}`,
        null,
        config
      )
      dispatch({
        type: types.EXPORT_SUCCESS,
        payload: data.data
      })
      handleAlert('Success', data?.status?.message, 'success')
      window.open(data.data.fileUrl, '_blank')
      if (callback) callback()
    } catch (error) {
      dispatch({
        type: types.EXPORT_FAILURE,
        payload: error.response?.data?.message || error.message
      })
      const code = error?.response?.status
      const message = error?.response?.data?.status?.message
      const errorDetail = error?.response?.data?.errors
      responseCodeAlert(code, message, errorDetail)
    }
  }

  const fileUploadAction = (request, callback) => async (dispatch) => {
    try {
      dispatch({ type: types.FILE_UPLOAD_REQUEST })
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}${endpoints.upload}`,
        request
      )
      dispatch({
        type: types.FILE_UPLOAD_SUCCESS,
        payload: data.data
      })
      handleAlert('Success', data?.status?.message, 'success')
      if (callback) callback()
    } catch (error) {
      dispatch({
        type: types.FILE_UPLOAD_FAILURE,
        payload: error.response?.data?.message || error.message
      })
      const code = error?.response?.status
      const message = error?.response?.data?.status?.message
      const errorDetail = error?.response?.data?.errors
      responseCodeAlert(code, message, errorDetail)
    }
  }

  const downloadTemplateAction = () => async (dispatch) => {
    try {
      dispatch({ type: types.DOWNLOAD_TEMPLATE_REQUEST })
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}${endpoints.downloadTemplate}`
      )
      dispatch({
        type: types.DOWNLOAD_TEMPLATE_SUCCESS,
        payload: data.data
      })
      handleAlert('Success', data?.status?.message, 'success')
      window.open(`${process.env.REACT_APP_API_BASE_URL}/${data.data.url}`, '_blank')
    } catch (error) {
      dispatch({
        type: types.DOWNLOAD_TEMPLATE_FAILURE,
        payload: error.response?.data?.message || error.message
      })
    }
  }

  return {
    types,
    actions: {
      listAction,
      detailListAction,
      detailAction,
      exportAction,
      fileUploadAction,
      downloadTemplateAction
    }
  }
}
